import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import PostCard from '../components/PostCard';
import TopUsersBox from '../components/TopUsersBox';
import '../styles/Home.css';

const Recommendations = () => {
  const { t } = useTranslation();
  // Redux dispatch available if needed for future state management
  const { user } = useSelector(state => state.auth);
  const [posts, setPosts] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchRecommendations = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/posts/public`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setPosts(response.data);
      } catch (err) {
        console.error('Error fetching recommendations:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchRecommendations();
  }, [token]);

  const handleLike = async (postId) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/posts/${postId}/like`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setPosts(posts.map(post => 
        post._id === postId 
          ? { ...post, likes: [...post.likes, user._id] }
          : post
      ));
    } catch (err) {
      console.error('Error liking post:', err);
    }
  };

  const handleComment = async (postId, text) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/posts/${postId}/comment`,
        { text },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setPosts(posts.map(post =>
        post._id === postId ? response.data.post : post
      ));
    } catch (err) {
      console.error('Error commenting:', err);
    }
  };

  return (
    <div className="home-container">
      <div className="home-layout">
        <div className="feed-section">
          <div style={{background: '#1a1a1a', padding: '1.5rem', borderBottom: '1px solid #2a2a2a', marginBottom: '1rem', borderRadius: '8px'}}>
            <h2 style={{color: '#1dd1a1', margin: 0}}>🌐 {t('common.discoverPosts') || 'Discover Posts'}</h2>
            <p style={{color: '#999', margin: '0.5rem 0 0 0'}}>{t('common.checkPostsFromAllUsers') || 'Check out posts from all users'}</p>
          </div>

          {loading && <div className="loading">{t('common.loading') || 'Loading'}...</div>}

          <div className="posts-list">
            {posts.length === 0 && !loading ? (
              <div style={{textAlign: 'center', color: '#666', padding: '2rem'}}>
                {t('common.noPostsYet') || 'No posts yet'}
              </div>
            ) : (
              posts.map(post => (
                <PostCard
                  key={post._id}
                  post={post}
                  onLike={handleLike}
                  onComment={handleComment}
                />
              ))
            )}
          </div>
        </div>

        <div className="sidebar-section">
          <TopUsersBox />
          
          <div className="suggestions-box">
            <div className="box-header">
              <h3>💡 {t('common.tips') || 'Tips'}</h3>
            </div>
            <div className="tips-list">
              <div className="tip-item">
                <span className="tip-icon">📝</span>
                <div>
                  <strong>{t('common.shareThoughts') || 'Share your thoughts'}</strong>
                  <p>{t('common.postRegularlyToStayEngaged') || 'Post regularly to stay engaged with your followers'}</p>
                </div>
              </div>
              <div className="tip-item">
                <span className="tip-icon">👥</span>
                <div>
                  <strong>{t('common.followInterestingPeople') || 'Follow interesting people'}</strong>
                  <p>{t('common.discoverNewContentFromUsers') || 'Discover new content from users you follow'}</p>
                </div>
              </div>
              <div className="tip-item">
                <span className="tip-icon">❤️</span>
                <div>
                  <strong>{t('common.engageWithContent') || 'Engage with content'}</strong>
                  <p>{t('common.likeAndCommentToSupport') || 'Like and comment to support other users'}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Recommendations;
